import { render } from "./SkeletonTable.vue?vue&type=template&id=7aeb6089"
import script from "./SkeletonTable.vue?vue&type=script&lang=js"
export * from "./SkeletonTable.vue?vue&type=script&lang=js"

import "./SkeletonTable.vue?vue&type=style&index=0&id=7aeb6089&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__